import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslations } from "next-intl";
import { apiErrorText } from "@/lib/api-error";
import { PLATFORM_AUTH_ERROR_OPTIONS } from "@/components/platform-admin/platform-login-form";
import { platformForgotPassword } from "@/services/api/platform-auth";

/** MT-1 AUTH-009 `/platform/forgot-password` (FR-6.9): the same answer for every address. */
export function PlatformForgotPasswordPage() {
  const t = useTranslations("platformAuth");
  const tRoot = useTranslations();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await platformForgotPassword(email.trim());
      setSent(true);
    } catch (err) {
      setError(apiErrorText(err, tRoot, "platformAuth.failed", PLATFORM_AUTH_ERROR_OPTIONS));
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="mx-auto flex min-h-screen max-w-md flex-col justify-center px-4">
      <h1 className="mb-6 text-2xl font-semibold">{t("forgotTitle")}</h1>
      {sent ? (
        <p role="status" data-testid="platform-forgot-sent">
          {t("forgotSent")}
        </p>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-4" data-testid="platform-forgot-form">
          <div>
            <label htmlFor="platform-forgot-email" className="mb-1 block text-sm font-medium">
              {t("emailLabel")}
            </label>
            <input
              id="platform-forgot-email"
              type="email"
              autoComplete="username"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full rounded-md border border-[var(--border-strong)] px-3 py-2"
            />
          </div>
          {error && (
            <p role="alert" className="text-sm text-[var(--danger)]">
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={busy}
            className="w-full rounded-md bg-[var(--accent-strong)] px-4 py-2 text-[var(--accent-foreground)] hover:bg-[var(--accent-strong-hover)] disabled:opacity-50"
          >
            {t("sendLink")}
          </button>
        </form>
      )}
      <p className="mt-4 text-center text-sm">
        <Link to="/platform/login" className="text-[var(--text-heading)] underline">
          {t("backToSignIn")}
        </Link>
      </p>
    </main>
  );
}
